<svg:rect *ngIf="(dimensions | async) as dimensions"
          class="listening-zone"
          [attr.x]="dimensions.marginLeft"
          [attr.y]="dimensions.marginTop"
          [attr.width]="dimensions.boundedWidth"
          [attr.height]="dimensions.boundedHeight" />
